var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ticket-download-wrapper" },
    [
      _vm.loading
        ? [
            _c("spinner"),
            _vm._v(" "),
            _c("p", { staticClass: "ticket-generation" }, [
              _vm._v(
                _vm._s(
                  _vm.$t("checkoutSuccess.ticketGeneration", {
                    progress: _vm.downloadLinkProgress,
                  })
                )
              ),
            ]),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.error ? [_vm._v(_vm._s(_vm.$t("checkoutSuccess.error")))] : _vm._e(),
      _vm._v(" "),
      _vm.ticketDownloadResponse
        ? [
            _vm.ticketDownloadResponse.tickets.length
              ? [
                  _vm._l(_vm.ticketDownloadResponse.tickets, function (ticket) {
                    return [
                      _c(
                        "div",
                        { staticClass: "ticket-download-item" },
                        [
                          _c("h3", [
                            _c("strong", [_vm._v(_vm._s(ticket.productTitle))]),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _c("strong", [
                              _vm._v(_vm._s(_vm.$t("titles.event")) + ":"),
                            ]),
                            _vm._v(" " + _vm._s(ticket.eventTitle)),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _c("strong", [
                              _vm._v(_vm._s(_vm.$t("titles.client")) + ":"),
                            ]),
                            _vm._v(" " + _vm._s(ticket.clientTitle)),
                          ]),
                          _vm._v(" "),
                          ticket.name
                            ? [
                                _c("p", [
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.$t("titles.name")) + ":"),
                                  ]),
                                  _vm._v(" " + _vm._s(ticket.name)),
                                ]),
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          ticket.date
                            ? [
                                _c("p", [
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.$t("titles.date")) + ":"),
                                  ]),
                                  _vm._v(" " + _vm._s(ticket.date)),
                                ]),
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _c("p", [
                            _c("strong", [_vm._v("VVS:")]),
                            _vm._v(
                              " " +
                                _vm._s(
                                  ticket.pubTransIncluded
                                    ? _vm.$t("global.forms.yes")
                                    : _vm.$t("global.forms.no")
                                )
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "button",
                              attrs: { target: "_blank", href: ticket.linkPdf },
                            },
                            [_vm._v("PDF Download")]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "button",
                              attrs: {
                                target: "_blank",
                                href: ticket.linkWallet,
                              },
                            },
                            [_vm._v("Wallet Download")]
                          ),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("hr"),
                    ]
                  }),
                ]
              : [
                  _c("p", [
                    _vm._v(_vm._s(_vm.$t("checkoutSuccess.noTickets"))),
                  ]),
                ],
            _vm._v(" "),
            _vm.ticketDownloadResponse.registrationCodes.length
              ? [
                  _c("p", [
                    _vm._v(
                      _vm._s(_vm.$t("checkoutSuccess.registrationCodes")) + ": "
                    ),
                    _c("strong", [
                      _vm._v(
                        _vm._s(
                          _vm.ticketDownloadResponse.registrationCodes.join(
                            " - "
                          )
                        )
                      ),
                    ]),
                    _vm._v("."),
                  ]),
                ]
              : _vm._e(),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }